import {
  createBrowserRouter,
  RouteObject,
  RouterProvider,
} from 'react-router-dom';
import { ConfigProvider } from 'antd';
import enUS from 'antd/locale/en_US';
import zhTW from 'antd/locale/zh_TW';
import './i18n';
import { routes } from './routes/routes';
import { SessionProvider } from 'context/SessionContext';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';

const router = createBrowserRouter(routes as RouteObject[], {
  basename: process.env.PUBLIC_URL,
  //for dealing with warnings
  future: {
    v7_skipActionErrorRevalidation: true,
    v7_normalizeFormMethod: true,
    v7_relativeSplatPath: true,
    v7_fetcherPersist: true,
    v7_partialHydration: true,
  },
});

function App() {
  const { i18n } = useTranslation();

  // Dynamically select Ant Design locale based on i18n language
  const antdLocale = useMemo(() => {
    return i18n.language === 'zh' ? zhTW : enUS;
  }, [i18n.language]);

  return (
    <ConfigProvider
      locale={antdLocale}
      theme={{
        token: {
          // Seed Token
          colorPrimary: '#009DDC',
          fontFamily: '"Open Sans", -apple-system, "Segoe UI", sans-serif',
        },
        components: {
          Menu: { fontSize: 16 },
          Dropdown: { fontSize: 16 },
          Tag: { fontSizeSM: 11 },
          Radio: { fontSize: 16 },
          Select: {
            fontSize: 16,
            controlHeight: 56,
          },
          Skeleton: {
            paragraphLiHeight: 24,
            titleHeight: 24,
          },
          Form: {
            labelFontSize: 12,
            fontSize: 16,
          },
          Input: {
            controlHeight: 56,
            fontSize: 16,
          },
          InputNumber: { controlHeight: 56 },
          Button: {
            controlHeight: 56,
            fontSize: 16,
            colorLink: '#009DDC',
            fontWeight: 700,
          },
          DatePicker: {
            controlHeight: 56,
            fontSize: 16,
          },
        },
      }}
    >
      <SessionProvider>
        {/* react-router-dom */}
        <RouterProvider future={{ v7_startTransition: true }} router={router} />
      </SessionProvider>
    </ConfigProvider>
  );
}

export default App;
